<span>{{ message() }}</span>
<app-progress-bar label="Progresso do download" [progress]="progress()" />
